import axios from "../../utils/axios";

export const getUsers = async ({ searchKeyword, pageNumber, pageSize }) => {
  const res = await axios.get("auth/users/getList", {
    params: {
      searchKeyword,
      pageNumber,
      pageSize,
    },
  });

  return res;
};

export const deleteUserById = async (id) => {
  const res = await axios.delete(`auth/users/${id}`);

  return res;
};

export const createUser = async (formData) => {
  const res = await axios.post("auth/users/create", formData);

  console.log(res);

  return res;
};

export const updateUserById = async (id, userData) => {
  const res = await axios.put(`auth/users/${id}`, userData);

  return res;
};
